import ConfidenceReason from './ConfidenceReason';

export default ConfidenceReason;

export type { IConfidenceReasonProps } from './ConfidenceReason';
